import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { CaseLookupComponent } from 'src/app/search/case-lookup.component';
import { AgendaLookupComponent } from 'src/app/agenda/agenda-lookup.component';
import { MinutesLookupComponent } from 'src/app/minutes/minutes-lookup.component';

const routes: Routes = [
  {path: 'home', component: HomeComponent},
  {path: 'search', component: CaseLookupComponent},
  {path: 'agenda', component: AgendaLookupComponent},
  {path: 'minutes', component: MinutesLookupComponent},
  {path: '', redirectTo: 'home', pathMatch: 'full'},
  {path: '**', redirectTo: 'home', pathMatch: 'full'}

];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
